module.exports = __webpack_public_path__ + "media/images/badges/ecological-explorations-100-ae719f26e882bf8cde4e4c50e8955c43.svg";